const defaultState = {
  simulationConfigs: {},
};

const getters = {
  all: state => Object.values(state.simulationConfigs),
  simulationConfigs: state => state.simulationConfigs,
};

const mutations = {
  setSimulationConfigs(state, configs) {
    configs.forEach(config => {
      state.simulationConfigs[config.categoryId] = config;
    });
  },
};

const actions = {
  fetchAfqtScore({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].get('/afqt', { params }).then(response => {
      return response.data;
    });
  },
  resetSimulation({ dispatch, commit, getters, rootGetters }, params) {
    const url = `/test_simulations/${params.categoryId}/reset`;
    return rootGetters['session/ajax'].post(url);
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
